export default __webpack_public_path__ + "static/media/logo-crowd.447acc14.svg";